import React, { useEffect, useRef, useState } from 'react';
import './MentorsProfileStyle.css';
import SearchBar from '../../../components/SearchBar/SearchBar';
import Dropdownmenu from '../../../components/Dropdownmenu/Dropdownmenu';
import { useNavigate } from 'react-router-dom';
import AdviewCallhistory from '../../../components/Popups/ViewCallDetails/AdviewCallhistory';
import Button from '../../../components/Button/Button';
import DatanotFound from '../../../components/DatanotFound/DatanotFound';
import moment from 'moment';
import Paginationarrow from '../../../components/Paginationarrow/Paginationarrow';
import Dorpwoncustom from '../../../components/Dorpwoncustom/Dorpwoncustom';
import Skeleton from 'react-loading-skeleton';

function CallHistoryMentors({ isActiveTab, isFetching, isUpcomingCalls, setIsUpcomingCalls, upcomingCalls, pastCalls, onClickViewCallDetails, upcoming, past, handleLoadMore, handleStatusFilter, handleSearch, handleSearchPress, handleSearchChange }) {

    const statusOptions = [
        {
            label: "All",
            value: ""
        },
        {
            label: "Completed",
            value: "completed"
        },
        {
            label: "Cancelled",
            value: "cancelled"
        },
        {
            label: "Rescheduled",
            value: "rescheduled"
        },
        {
            label: "Unattended",
            value: "pending"
        },
    ];

    const [viewdropdown, setviewdropdown] = useState();

    const navigate = useNavigate();

    const targetRef = useRef(null);

    useEffect(() => {

        const allElements = document.querySelectorAll(".CallHistoryTabledata");
        const allElements1 = document.querySelectorAll(".innerdiv");

        let element = allElements[0];
        let element1 = allElements1[0];
        if (isUpcomingCalls) {
            element = allElements[0];
            element1 = allElements1[0];
        };
        if (!isUpcomingCalls) {
            element = allElements[1];
            element1 = allElements1[1];
        };

        const handleScroll = () => {
            if (targetRef.current) {
                const { top } = targetRef.current.getBoundingClientRect();
                const windowHeight = window.innerHeight || document.documentElement.clientHeight;

                if (top <= windowHeight) {
                    handleLoadMore();
                }
            }
        };

        element.addEventListener('scroll', handleScroll);
        element1.addEventListener('scroll', handleScroll);

        return () => {
            element.removeEventListener('scroll', handleScroll);
            element1.removeEventListener('scroll', handleScroll);
        };
    }, [handleLoadMore]);

    return (

        <div className={`callHIstoryWrap hsResfixtable tabWrapper ${isActiveTab && 'active'}`}>
            {/* <AdviewCallhistory isActive={viewCallDetails} setIsActive={setViewCallDetails} /> */}
            <div className={`commonTableWrapper ContainerTabForAllTabData  Adcallhsmentor`}>

                <div className='Headingforallheader'>
                    <h2 className='heading-2'>Call Details</h2>
                </div>

                <div className="border-btm w-100"></div>
                <div className='bodyDataForallUserdata'>
                    <div className="headingwrap flex-between mb-30">
                        {isFetching ? <Skeleton width={"80px"} /> : <div className='Adtextoverall'> Total <span> {isUpcomingCalls ? upcoming?.totalCount ?? 0 : past?.totalCount ?? 0}</span> </div>}
                        {isFetching ? <Skeleton width={"160px"} height={"30px"} /> : <div className="btnRightsidesale pillButtons">
                            <Button className={isUpcomingCalls && 'active'} name={'Upcoming'} onClick={() => setIsUpcomingCalls(true)} />
                            <Button className={!isUpcomingCalls && 'active'} name={'Past'} onClick={() => setIsUpcomingCalls(false)} />
                        </div>}
                    </div>

                    <div className="FaqUserFiltter flex-between">
                        {isFetching ? <Skeleton width={"280px"} height={"40px"} /> : <SearchBar placeholder={'Search here...'} className={'searchbardesign'} onChange={handleSearchChange} onKeyDown={handleSearchPress} onClick={handleSearch} />}
                        <div className="FilterButtonPast flex gap-10" >
                            {isFetching ? <Skeleton width={"200px"} height={"40px"} /> : <div className='dropdownbtnshow'>
                                <input type='text' placeholder={`Showing ${isUpcomingCalls ? upcomingCalls?.length ?? 0 : pastCalls?.length ?? 0} out of ${isUpcomingCalls ? upcoming?.totalCount ?? 0 : past?.totalCount ?? 0}`} disabled className='disabledInput' />
                            </div>}
                            {/* <label htmlFor="date" className='Cudatedesign'>
                                <input type="date" id='date' />
                            </label> */}
                        </div>
                    </div>
                    <div className='wrapperdivheight'>
                        <div className={`CallHistoryTabledata mt20 fixhismentor1 Tabusesate ${isUpcomingCalls && 'active'}`}>

                            <div className="outerdiv">
                                <table>
                                    <thead>
                                        <tr className='headingTabletr'>
                                            <th>Mentee</th>
                                            <th>Agenda</th>
                                            <th>Date</th>
                                            <th>Time</th>
                                        </tr>

                                    </thead>
                                </table>
                            </div>

                            <div className="innerdiv">
                                <table>
                                    <tbody>
                                        {upcomingCalls?.length > 0 ? upcomingCalls?.map((item, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <div className="tableBox">
                                                        <div className='Adminprofileimageuser'>
                                                            <img src={item?.mentee?.profileImg ? item?.mentee?.profileImg : "/assets/img/User.png"} alt="" className='pointer' />
                                                        </div>
                                                        <div className='Namedetails'>
                                                            <h4 className='namelink mb4 navigatetext' onClick={() => navigate(`/admin/mentee-profile/${item?.mentee?.id}`)}>{item?.mentee?.firstName ? `${item?.mentee?.firstName} ${item?.mentee?.lastName}` : "---"}</h4>
                                                            <p className="text2">{item?.mentee?.profession?.title ? item?.mentee?.profession?.title === "work" ? 'Working Professional' : 'Student' : "---"}</p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='tableBox'>
                                                        <h4>{item?.agenda ? item?.agenda : "---"}</h4>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='tableBox dsblock'>
                                                        <h4>{item?.startTime ? moment(item?.startTime).utcOffset("-00:00").format("DD MMMM") : "---"}</h4>
                                                        <p className='text2'>{item?.startTime ? moment(item?.startTime).utcOffset("-00:00").format("dddd") : "---"}</p>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="tableBox">
                                                        <h4>{item?.startTime ? moment(item?.startTime).utcOffset("-00:00").format("h:mm a") : "---"}</h4>
                                                    </div>
                                                </td>
                                            </tr>
                                        )) : !isFetching && <DatanotFound />}
                                        {isFetching &&
                                            <>
                                                {[1, 2, 3].map(item => (
                                                    <tr key={item}>
                                                        <td>
                                                            <div className="tableBox">
                                                                <div className='Adminprofileimageuser'>
                                                                    <Skeleton width={"50px"} height={"50px"} circle />
                                                                </div>
                                                                <div className='Namedetails'>
                                                                    <h4 className='namelink mb4 navigatetext'>{<Skeleton width={"100px"} />}</h4>
                                                                    <p className="text2">{<Skeleton width={"150px"} />}</p>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className='tableBox'>
                                                                <h4>{<Skeleton width={"300px"} />}</h4>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className='tableBox dsblock'>
                                                                <h4>{<Skeleton width={"100px"} />}</h4>
                                                                <p className='text2'>{<Skeleton width={"80px"} />}</p>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="tableBox">
                                                                <h4>{<Skeleton width={"80px"} />}</h4>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </>}
                                    </tbody>
                                </table>
                            {(!isFetching && ((isUpcomingCalls && upcoming?.calls?.length >= 10) || (!isUpcomingCalls && past?.calls?.length >= 10))) && <div className="lodeemorebutton mt10" ref={targetRef}>
                                <Button name={'Load More'} className={'BlueFillButton buttontext'} onClick={handleLoadMore} />
                            </div>}
                            </div>

                        </div>

                        <div className={`CallHistoryTabledata mt20 fixhismentor2 Tabusesate ${!isUpcomingCalls && 'active'}`}>

                            <div className="outerdiv">
                                <table>
                                    <thead>
                                        <tr className='headingTabletr'>
                                            <th>Mentee</th>
                                            <th>Agenda</th>
                                            <th>
                                                <div className='dropdownwrapper flex pointer' onClick={() => setviewdropdown(!viewdropdown)}>Status
                                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M10.4534 4.77173H6.81926H3.54676C2.98676 4.77173 2.70676 5.4484 3.10343 5.84506L6.1251 8.86673C6.60926 9.35089 7.39676 9.35089 7.88093 8.86673L9.0301 7.71756L10.9026 5.84506C11.2934 5.4484 11.0134 4.77173 10.4534 4.77173Z" fill="#737373" />
                                                    </svg>
                                                    <Dropdownmenu setviewdropdown={setviewdropdown} viewdropdown={viewdropdown} options={statusOptions} onChange={handleStatusFilter} />
                                                </div>
                                            </th>

                                            <th>Date</th>
                                            <th>Time</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>

                            <div className="innerdiv">
                                <table>
                                    <tbody>
                                        {pastCalls?.length > 0 ? pastCalls?.map((item, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <div className="tableBox">
                                                        <div className='Adminprofileimageuser'>
                                                            <img src={item?.mentee?.profileImg ? item?.mentee?.profileImg : "/assets/img/User.png"} alt="" className='pointer' />
                                                        </div>
                                                        <div className='Namedetails'>
                                                            <h4 className='namelink navigatetext mb4' onClick={() => navigate(`/admin/mentee-profile/${item?.mentee?.id}`)}>{item?.mentee?.firstName ? `${item?.mentee?.firstName} ${item?.mentee?.lastName}` : "---"}</h4>
                                                            <p className="text2">{item?.mentee?.profession?.title ? item?.mentee?.profession?.title === "work" ? 'Working Professional' : 'Student' : "---"}</p>
                                                        </div>
                                                    </div>
                                                </td>

                                                <td>
                                                    <div className='tableBox'>
                                                        <h4>{item?.agenda ? item?.agenda : "---"}</h4>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='tableBox'>
                                                        <div className='mentorProfilearea'>
                                                            <h4 className={`${item?.meetingStatus.toLowerCase()} Statuscheck capitilize`}>{item?.meetingStatus ? item?.meetingStatus === "pending" ? "No Show" : item?.meetingStatus : "---"}</h4>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="tableBox">
                                                        <div className='dsblock'>
                                                            <h4>{item?.startTime ? moment(item?.startTime).utcOffset("-00:00").format("DD MMMM") : "---"}</h4>
                                                            <p className="text2">{item?.startTime ? moment(item?.startTime).utcOffset("-00:00").format("dddd") : "---"}</p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="tableBox">
                                                        <h4>{item?.startTime ? moment(item?.startTime).utcOffset("-00:00").format("h:mm a") : "---"}</h4>
                                                    </div>
                                                </td>

                                                <td>
                                                    <div className="tableBox">
                                                        <div className="tableBox">
                                                            <span className=" calendar pointer">
                                                                <img src="/assets/img/eye.png" alt="" onClick={() => onClickViewCallDetails(item?.id)} />
                                                            </span>
                                                        </div>
                                                    </div>
                                                </td>

                                            </tr>
                                        )) : !isFetching && <DatanotFound />}
                                        {isFetching &&
                                            <>
                                                {[511, 411, 311].map(item => (
                                                    <tr key={item}>
                                                        <td>
                                                            <div className="tableBox">
                                                                <div className='Adminprofileimageuser'>
                                                                    <Skeleton width={"50px"} height={"50px"} circle />
                                                                </div>
                                                                <div className='Namedetails'>
                                                                    <h4 className='namelink mb4 navigatetext'>{<Skeleton width={"100px"} />}</h4>
                                                                    <p className="text2">{<Skeleton width={"150px"} />}</p>
                                                                </div>
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <div className='tableBox'>
                                                                <h4>{<Skeleton width={"300px"} />}</h4>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className='tableBox'>
                                                                <div className='mentorProfilearea'>
                                                                    <h4 className={` capitilize`}>{<Skeleton width={"100px"} />}</h4>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="tableBox">
                                                                <div className='dsblock'>
                                                                    <h4>{<Skeleton width={"100px"} />}</h4>
                                                                    <p className="text2">{<Skeleton width={"80px"} />}</p>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="tableBox">
                                                                <h4>{<Skeleton width={"80px"} />}</h4>
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <div className="tableBox">
                                                                <div className="tableBox">
                                                                    <Skeleton width={"30px"} height={"30px"} circle />
                                                                </div>
                                                            </div>
                                                        </td>

                                                    </tr>
                                                ))}
                                            </>}
                                    </tbody>
                                </table>
                            {(!isFetching && ((isUpcomingCalls && upcoming?.calls?.length >= 10) || (!isUpcomingCalls && past?.calls?.length >= 10))) && <div className="lodeemorebutton mt10" ref={targetRef}>
                                <Button name={'Load More'} className={'BlueFillButton buttontext'} onClick={handleLoadMore} />
                            </div>}
                            </div>

                        </div>

                    </div>
                </div>
            </div>
            {/* <Paginationarrow /> */}
        </div>
    )
}

export default CallHistoryMentors